<template>
  <div fluid class="mb-4 background-container admin-home">
    <b-row>
      <div class="collections-selection background-container">
        <CollectionsSelection
          @collectionSelected="goCollectionsView"
          :routeSelectedCollection="collectionSelected"
        ></CollectionsSelection>
      </div>
      <div class="database-screen background-container">
        <router-view></router-view>
        <div class="placeholder-container background-container" v-if="route.path === '/admin'">
          <div>
            <i class="ri-database-line icon-large"></i>
            <h6>Select a collection to get started.</h6>
          </div>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import { xray } from '../../config/pluginInit'
import { ref, onMounted, watch } from 'vue'
import CollectionsSelection from './Database/CollectionsSelection.vue'
import 'vue-loading-overlay/dist/css/index.css'
import { useRouter, useRoute } from 'vue-router'

export default {
  mounted () {
    xray.index()
  },
  components: { CollectionsSelection },
  setup (props, context) {
    const collectionSelected = ref(null)
    const router = useRouter()
    const route = useRoute()

    onMounted(() => {
      if (route.path !== '/admin') {
        collectionSelected.value = route.path.split('/').pop()
      }
    })

    watch(route, () => {
      if (route.path !== '/admin') {
        collectionSelected.value = route.path.split('/').pop()
      } else {
        collectionSelected.value = null
      }
    })

    const goCollectionsView = (collectionId) => {
      router.push({ name: 'admin.collection', params: { collection: collectionId } })
    }

    return {
      collectionSelected,
      route,
      goCollectionsView
    }
  }
}
</script>

<style scoped>
.admin-home {
  padding: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.collections-selection {
  width: 20%;
  border-right: 1px solid var(--border-color);
  border-radius: 4px 0 0 4px !important;
}

.database-screen {
  width: 80%;
}

.icon-large {
  font-size: 3rem;
}

</style>

